import { render, staticRenderFns } from "./ContactEmail.vue?vue&type=template&id=232fba55&"
import script from "./ContactEmail.vue?vue&type=script&lang=ts&"
export * from "./ContactEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports